export default __webpack_public_path__ + "static/media/kabaddi.a55ad454.png";